
const urls = {
  // 获取sdkconfig
  getSdkConfig:"/api/wx_share",
  // 获取活动信息
  getEventInfo:"/api",
}

export default urls